import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { ToastContainer } from 'react-toastify';
import { DetectReceiptFraud } from './containers/DetectReceiptFraud';
import { DetectAbnormalLayout } from './containers/DetectAbnormalLayout';
import './App.css';
import 'react-toastify/dist/ReactToastify.css';

function App() {
  return (
    <Router>
      <ToastContainer
        position="top-right"
        autoClose={5000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="light"
      />
      <Routes>
        <Route path="/detect-receipt-fraud" element={<DetectReceiptFraud />} />
        <Route path="/detect-abnormal-layout" element={<DetectAbnormalLayout />} />
        <Route path="*" element={<Navigate to="/detect-receipt-fraud" replace />} />
      </Routes>
    </Router>
  );
}

export default App;
